export const quoteErrorKey = (error: any) => {
  const data = error?.response?.data;
  if (data?.missing_settings?.some((row: any) => (row.material === false || row.material === "False") && row.processing === "unit")) return "order.missingUnitRate";
  return data?.missing_prices ? "order.missingConfiguration" : "order.generationFailed";
};

/** Server diagnostics identify real missing rates rather than guessing from totals. */
export const quoteErrorMessage = (error: any, t: any): string => {
  const rows = error?.response?.data?.missing_settings;
  if (!Array.isArray(rows) || !rows.length) return t(quoteErrorKey(error));
  const missing: string[] = [];
  rows.forEach((row: any) => {
    const context = {
      kind: t(`order.itemKind.${row.kind || "rebar"}`),
      row: row.row_number ?? row.item,
      diameter: row.diameter == null || row.diameter === "None" ? t("order.unknownDiameter") : Number(row.diameter),
    };
    if (row.material === true || row.material === "True") {
      missing.push(t("order.missingMaterialDetail", { ...context, material: t(`order.materialKind.${row.material_field || "ribbed"}`) }));
    }
    if (row.processing_missing === true || row.processing_missing === "True" ||
      (row.processing_missing == null && (row.material === false || row.material === "False"))) {
      const categories = Array.isArray(row.missing_processing) && row.missing_processing.length ? row.missing_processing : [row.processing];
      categories.forEach((category: string) => missing.push(t("order.missingProcessingDetail", { ...context, processing: t(`processing.${category === "unit" ? "unitPrice" : category}`) })));
    }
  });
  return missing.length ? `${t("order.missingPricesHeading")} ${missing.join("; ")}` : t(quoteErrorKey(error));
};
